import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import Leaderboard from "../../components/Home/LeaderBoard";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import TrendingItem from "../../components/Home/TrendingItem";
import axios from "axios";
import { toast } from "react-toastify";
import Loader from "../../components/Utils/Loader";
import PageContainer from "../../pages/PageContainer";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import ExpandLessRoundedIcon from "@mui/icons-material/ExpandLessRounded";
import { Link } from "react-router-dom";

const trendingData = [
  {
    title: "Trending in Scoring",
    date: "Yesterday",
    players: [
      {
        id: "ach2",
        name: "Aaliyah Chavez",
        profileImg:
          "https://s3media.247sports.com/Uploads/Assets/218/449/12449218.jpg?width=70&fit=crop",
        stats: [
          { value: 28, label: "points" },
          { value: "60%", label: "FG" },
          { value: "12/20", label: "FG" },
        ],
        result: "Win",
        event: "Game @ event",
        xfactor: "90",
      },
      {
        id: "jd2",
        name: "Jasmine Davidson",
        profileImg:
          "https://s3media.247sports.com/Uploads/Assets/444/456/12456444.png?width=70&fit=crop",
        stats: [
          { value: 25, label: "points" },
          { value: "65%", label: "FG" },
          { value: "11/16", label: "FG" },
        ],
        result: "Loss",
        event: "Game @ event",
        xfactor: "83",
      },
    ],
  },
  {
    title: "Trending in Rebounds",
    date: "3 Days Ago",
    players: [
      {
        id: "dp2",
        name: "Deniya Prawl",
        profileImg:
          "https://s3media.247sports.com/Uploads/Assets/321/467/12467321.jpeg?width=70&fit=crop",
        stats: [
          { value: 14, label: "Rebounds" },
          { value: 10, label: "OFF" },
          { value: 4, label: "DEF" },
        ],
        result: "Win",
        event: "Game @ event",
        xfactor: "91",
      },
      {
        id: "bm2",
        name: "Brynn McGaughy",
        profileImg:
          "https://s3media.247sports.com/Uploads/Assets/558/449/12449558.jpg?width=70&fit=crop",
        stats: [
          { value: 12, label: "Rebounds" },
          { value: 5, label: "OFF" },
          { value: 7, label: "DEF" },
        ],
        result: "Win",
        event: "Game @ Event Name",
        xfactor: "79",
      },
    ],
  },
  {
    title: "Trending in Assists",
    date: "Today",
    players: [
      {
        id: "ad2",
        name: "Addie Deal",
        profileImg:
          "https://s3media.247sports.com/Uploads/Assets/329/456/12456329.jpeg?width=70&fit=crop",
        stats: [
          { value: 11, label: "Assists" },
          { value: 0, label: "Turnovers" },
        ],
        result: "Win",
        event: "Game @ event",
        xfactor: "89",
      },
      {
        id: "hs2",
        name: "Hailee Swain",
        profileImg:
          "https://s3media.247sports.com/Uploads/Assets/316/582/12582316.jpg?width=70&fit=crop",
        stats: [
          { value: 9, label: "Assists" },
          { value: 1, label: "Turnover" },
        ],
        result: "Loss",
        event: "Game @ event",
        xfactor: "81",
      },
    ],
  },
];
const WomensHome = () => {
  const [loading, setLoading] = useState(true);
  const [leaderboardData, setLeaderboardData] = useState({
    pointsLeaderboard: [],
    assistsLeaderboard: [],
    reboundsLeaderboard: [],
    overallLeaderboard: [],
    defenseLeaderboard: [],
    playmakingLeaderboard: [],
    ball_handlingLeaderboard: [],
  });
  const [expandedBoards, setExpandedBoards] = useState({
    overall: false,
    points: false,
    rebounds: false,
    assists: false,
    defense: false,
    playmaking: false,
    ball_handling: false,
  });

  const toggleBoard = (board) => {
    setExpandedBoards((prev) => ({
      ...prev,
      [board]: !prev[board],
    }));
  };

  useEffect(() => {
    // // Fetch player list
    axios
      .post("/api/players/leaderboard-data", { withCredentials: true })
      .then((response) => {
        console.log("back");
        setLeaderboardData(response.data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        toast.error("Failed to load players");
      });
  }, []);
  if (loading) {
    return <Loader />;
  }
  return (
    <PageContainer>
      <Grid container spacing={2}>
        <Grid className="trending-home-container" xs={12} md={6}>
          {trendingData.map((data, index) => (
            <TrendingItem
              key={index}
              title={data.title}
              date={data.date}
              players={data.players}
            />
          ))}
        </Grid>
        <Grid xs={12} md={6}>
          <div className="leader-home">
            <div
              className="trending-home-header"
              onClick={() => toggleBoard("overall")}
              style={{ cursor: "pointer" }}
            >
              <p className="trending-home-title">
                <EmojiEventsIcon
                  sx={{ color: "#5d87ff", verticalAlign: "bottom" }}
                />
                Overall Leaderboard
              </p>
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <span style={{ opacity: "0.4" }}>Updated 2 hours ago</span>
                {expandedBoards.overall ? (
                  <ExpandLessRoundedIcon />
                ) : (
                  <ExpandMoreRoundedIcon />
                )}
              </div>
            </div>
            {expandedBoards.overall && (
              <>
                <div className="leader-home-content">
                  <Leaderboard
                    data={leaderboardData.overallLeaderboard}
                    type="overall"
                  />
                </div>
                <Link
                  to="/leaderboard?type=overall"
                  className="leader-home-see-full"
                >
                  See Full List →
                </Link>
              </>
            )}
          </div>
          <div className="leader-home">
            <div
              className="trending-home-header"
              onClick={() => toggleBoard("points")}
              style={{ cursor: "pointer" }}
            >
              <p className="trending-home-title">
                <EmojiEventsIcon
                  sx={{ color: "#5d87ff", verticalAlign: "bottom" }}
                />
                Points
              </p>
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <span style={{ opacity: "0.4" }}>Updated 2 hours ago</span>
                {expandedBoards.points ? (
                  <ExpandLessRoundedIcon />
                ) : (
                  <ExpandMoreRoundedIcon />
                )}
              </div>
            </div>
            {expandedBoards.points && (
              <>
                <div className="leader-home-content">
                  <Leaderboard
                    data={leaderboardData.pointsLeaderboard}
                    type="points"
                  />
                </div>
                <Link
                  to="/leaderboard?type=points"
                  className="leader-home-see-full"
                >
                  See Full List →
                </Link>
              </>
            )}
          </div>
          <div className="leader-home">
            <div
              className="trending-home-header"
              onClick={() => toggleBoard("rebounds")}
              style={{ cursor: "pointer" }}
            >
              <p className="trending-home-title">
                <EmojiEventsIcon
                  sx={{ color: "#5d87ff", verticalAlign: "bottom" }}
                />
                Rebounds
              </p>
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <span style={{ opacity: "0.4" }}>Updated 2 hours ago</span>
                {expandedBoards.rebounds ? (
                  <ExpandLessRoundedIcon />
                ) : (
                  <ExpandMoreRoundedIcon />
                )}
              </div>
            </div>
            {expandedBoards.rebounds && (
              <>
                <div className="leader-home-content">
                  <Leaderboard
                    data={leaderboardData.reboundsLeaderboard}
                    type="rebounds"
                  />
                </div>
                <Link
                  to="/leaderboard?type=rebounds"
                  className="leader-home-see-full"
                >
                  See Full List →
                </Link>
              </>
            )}
          </div>
          <div className="leader-home">
            <div
              className="trending-home-header"
              onClick={() => toggleBoard("assists")}
              style={{ cursor: "pointer" }}
            >
              <p className="trending-home-title">
                <EmojiEventsIcon
                  sx={{ color: "#5d87ff", verticalAlign: "bottom" }}
                />
                Assists
              </p>
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <span style={{ opacity: "0.4" }}>Updated 2 hours ago</span>
                {expandedBoards.assists ? (
                  <ExpandLessRoundedIcon />
                ) : (
                  <ExpandMoreRoundedIcon />
                )}
              </div>
            </div>
            {expandedBoards.assists && (
              <>
                <div className="leader-home-content">
                  <Leaderboard
                    data={leaderboardData.assistsLeaderboard}
                    type="assists"
                  />
                </div>
                <Link
                  to="/leaderboard?type=assists"
                  className="leader-home-see-full"
                >
                  See Full List →
                </Link>
              </>
            )}
          </div>
          <div className="leader-home">
            <div
              className="trending-home-header"
              onClick={() => toggleBoard("defense")}
              style={{ cursor: "pointer" }}
            >
              <p className="trending-home-title">
                <EmojiEventsIcon
                  sx={{ color: "#5d87ff", verticalAlign: "bottom" }}
                />
                Defense
              </p>
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <span style={{ opacity: "0.4" }}>Updated 2 hours ago</span>
                {expandedBoards.defense ? (
                  <ExpandLessRoundedIcon />
                ) : (
                  <ExpandMoreRoundedIcon />
                )}
              </div>
            </div>
            {expandedBoards.defense && (
              <>
                <div className="leader-home-content">
                  <Leaderboard
                    data={leaderboardData.defenseLeaderboard}
                    type="defense"
                  />
                </div>
                <Link
                  to="/leaderboard?type=defense"
                  className="leader-home-see-full"
                >
                  See Full List →
                </Link>
              </>
            )}
          </div>
          <div className="leader-home">
            <div
              className="trending-home-header"
              onClick={() => toggleBoard("playmaking")}
              style={{ cursor: "pointer" }}
            >
              <p className="trending-home-title">
                <EmojiEventsIcon
                  sx={{ color: "#5d87ff", verticalAlign: "bottom" }}
                />
                Playmaking
              </p>
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <span style={{ opacity: "0.4" }}>Updated 2 hours ago</span>
                {expandedBoards.playmaking ? (
                  <ExpandLessRoundedIcon />
                ) : (
                  <ExpandMoreRoundedIcon />
                )}
              </div>
            </div>
            {expandedBoards.playmaking && (
              <>
                <div className="leader-home-content">
                  <Leaderboard
                    data={leaderboardData.playmakingLeaderboard}
                    type="playmaking"
                  />
                </div>
                <Link
                  to="/leaderboard?type=playmaking"
                  className="leader-home-see-full"
                >
                  See Full List →
                </Link>
              </>
            )}
          </div>
          <div className="leader-home">
            <div
              className="trending-home-header"
              onClick={() => toggleBoard("ball_handling")}
              style={{ cursor: "pointer" }}
            >
              <p className="trending-home-title">
                <EmojiEventsIcon
                  sx={{ color: "#5d87ff", verticalAlign: "bottom" }}
                />
                Ball Handling
              </p>
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <span style={{ opacity: "0.4" }}>Updated 2 hours ago</span>
                {expandedBoards.ball_handling ? (
                  <ExpandLessRoundedIcon />
                ) : (
                  <ExpandMoreRoundedIcon />
                )}
              </div>
            </div>
            {expandedBoards.ball_handling && (
              <>
                <div className="leader-home-content">
                  <Leaderboard
                    data={leaderboardData.ball_handlingLeaderboard}
                    type="ball_handling"
                  />
                </div>
                <Link
                  to="/leaderboard?type=ball_handling"
                  className="leader-home-see-full"
                >
                  See Full List →
                </Link>
              </>
            )}
          </div>
        </Grid>
      </Grid>
    </PageContainer>
  );
};

export default WomensHome;
